import U2000InputText from "../../../../u2000Core/components/formControls/input/U2000InputText";
import type { U2000FormStateHandlers } from "../../../../u2000Core/reducer/formReducer/U2000FormStateHandlers";
import type { TFunction } from "i18next";
import { NS } from "../../../U2102";

// Typage des props du composant
interface U2102RoleComponentProps<T extends Record<string, any>> {
  formStateHandlers: U2000FormStateHandlers<T>;
  t: TFunction;
}

function U2102RoleBody<T extends Record<string, any>>({ formStateHandlers, t }: U2102RoleComponentProps<T>) {
  return (
    <div className="grid grid-cols-2 gap-4">
      <U2000InputText fieldName="roleCode" label={t("lblRoleCode", { ns: NS })} formStateHandlers={formStateHandlers} />
      <U2000InputText fieldName="roleDescription" label={t("lblRoleDescription", { ns: NS })} formStateHandlers={formStateHandlers} />
    </div>
  );
}

export default U2102RoleBody;
